import * as api from './api';

export const login = (params:{email: string; password: string})=>{
  return api.post('/login',params);
}

export const changePassword = async(token: string, params:{email: string; oldPassword: string; newPassword: string})=>{
  try{
    api.setHeaderAuthorization(token);
    const response = await api.post('/change-password',params);
    return response;
  }catch (error){
    throw error;
  }
}


export const logout = async (token: string)=>{
  try{
    api.setHeaderAuthorization(token);
    const response = await api.post('/logout',{});
    api.setHeaderAuthorization(null);
    return response;
  }catch (error) {
    api.setHeaderAuthorization(null);
    throw error;
  }
}